/**
 * External URLs and contact information
 * Centralized here for easy updates across the site
 */

/**
 * Origin of the professional dashboard the marketing site hands off to.
 *
 * Env-overridable (IDEA-260608-nngh) so the /get-started → signup handoff
 * (ICP params + the #295 email-prefill) can be exercised against a non-prod
 * dashboard instead of only prod. Defaults to prod, so a zero-config build is
 * unchanged. To QA the handoff end-to-end, set VITE_DASHBOARD_ORIGIN, e.g.:
 *   VITE_DASHBOARD_ORIGIN=https://staging.dashboard.neumind.io  (staging)
 *   VITE_DASHBOARD_ORIGIN=https://dev.dashboard.neumind.io      (dev)
 *   VITE_DASHBOARD_ORIGIN=http://localhost:5173                 (local dashboard)
 * (Canonical per-env origins mirror app/utils/environment.ts.)
 */
const DASHBOARD_ORIGIN = (
  import.meta.env.VITE_DASHBOARD_ORIGIN || 'https://dashboard.neumind.io'
).replace(/\/+$/, ''); // strip trailing slash so derived URLs never double-slash

export const ExternalUrls = {
  /** Main dashboard for professionals */
  dashboard: DASHBOARD_ORIGIN,
  /** Dashboard signup page */
  dashboardSignup: `${DASHBOARD_ORIGIN}/signup`,
  /** Dashboard signup/onboarding flow */
  dashboardStart: `${DASHBOARD_ORIGIN}/signup`,
  /** Mobile app download/redirect */
  app: 'https://app.neumind.io',
  /** Support documentation hub */
  support: 'https://support.neumind.io',
  /** Calendly booking link for demos */
  calendly: 'https://calendly.com/ellis-neumind/demo-call',
} as const;

export const ContactInfo = {
  email: 'hello@neumind.io',
  emailLink: 'mailto:hello@neumind.io',
  telephone: '(+44) 01223 239990',
} as const;


